const namespace = "blastRegistration";

export const TOP_PRIZE_POOL = `${namespace}.topPrizePool`;
export const UNREGISTER = `${namespace}.unregister`;
export const WAITING = `${namespace}.waiting`;
